import alert from './alert.vue';

export default function(msg, options = {}) {
    this.$overlay(alert, { ...options, msg }).open();
}
